'use client';

import { mergeThemeOverrides, createTheme } from '@mantine/core';
import { commonTheme } from './common.mjs';
var rahoituTheme = mergeThemeOverrides(commonTheme, createTheme({
  primaryShade: 5
}));
export { rahoituTheme };